import { render, staticRenderFns } from "./ProductsGoalDetails.vue?vue&type=template&id=78731b30&"
import script from "./ProductsGoalDetails.vue?vue&type=script&lang=js&"
export * from "./ProductsGoalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports